import {AnyEvent, JOB_COMPANIES_DELETED_EVENT, JobCompaniesDeletedEvent} from '../type';

export default function jobCompaniesDeleted(payload: JobCompaniesDeletedEvent['payload']): AnyEvent {
  return {
    type: JOB_COMPANIES_DELETED_EVENT,
    payload,
  }
}